import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { GetInvestigationPrioritySnapshotsQuery } from './get-priority-snapshots.query';
import { GetInvestigationPrioritySnapshotsResult } from './get-priority-snapshots.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationPrioritySnapshotsUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetInvestigationPrioritySnapshotsQuery): Observable<GetInvestigationPrioritySnapshotsResult> {
    this._state.setLoadingPrioritySnapshots(true);
    this._state.setErrorPrioritySnapshots(null);

    return this._repository.getPrioritySnapshots(query.investigationId).pipe(
      tap((prioritySnapshots) => {
        this._state.setPrioritySnapshots(prioritySnapshots);
        this._state.setLoadingPrioritySnapshots(false);
      }),
      map((prioritySnapshots) => ({ prioritySnapshots })),
      catchError((error) => {
        this._state.setErrorPrioritySnapshots(error.message || 'Failed to get priority snapshots');
        this._state.setLoadingPrioritySnapshots(false);
        return throwError(() => error);
      }),
    );
  }
}
